import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import FooterImages from './footerImages.vue';
import { FooterImagesItem } from '@/view/home/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'footerText',
  props: {
    itemData: {}
  },
  emits: ['openContactPopup'],
  setup(__props: any, { emit: __emit }) {

const footerHtmlText = ref('')
const props = __props
const emits = __emit
const openContactPopup = () => {
    emits('openContactPopup')
}
onMounted(() => {
    footerHtmlText.value = props.itemData.htmlText
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(FooterImages, {
      "item-data": _ctx.itemData,
      onOpenContactPopup: openContactPopup
    }, null, 8, ["item-data"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { innerHTML: footerHtmlText.value }, null, 8, _hoisted_3)
      ])
    ])
  ], 64))
}
}

})